/**
 * @fileoverview MultipleRoles
 *
 * MultipleRoles page related components initialization
 */
import Modal from '../../components/Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Request from '../../utils/request';

class RolesOnboarding {
    
    constructor() {
        this._wrapper = SelectorEngine.findOne('#multiple-roles-modal');
        if(!this._wrapper) {
        return;
        }

        this.state = {
        roleType: '',
        roleRedirectUrl: '',
        };
        this._modal = undefined;
        this._modalTriggerSSBtn = undefined;
        this.initiateSection();
    }

    initiateSection() {
            const defultModal = document.querySelector('#multiple-roles-default-modal');
            const mainModal = document.querySelector('#multiple-roles-modal');

            this._defaultsModal = new Modal(defultModal, {});
            this._modal = new Modal(mainModal, {});

            this._backBtn = SelectorEngine.findOne('.js-multiple-roles-back', this._wrapper);
            this._modalTriggerSSBtn = SelectorEngine.findOne('.js-trigger-multiple-roles');
            this.startMultipleRolesJourney = SelectorEngine.findOne('.multiple-roles-onboarding-journey');
            this.nextSectionCtas = SelectorEngine.findOne('.js-next-section', this._wrapper);
            const forms = SelectorEngine.find('.lta-content--form-element', this._wrapper);
            this.errorContainer = SelectorEngine.findOne('.multiple-roles__cancellation-error', mainModal);
            this.dismissError = SelectorEngine.findOne('.js-multiple-roles-dismiss', mainModal);
            this.apiUrl = SelectorEngine.findOne('#multiple-roles-data-attr').getAttribute('data-api-url');

            EventHandler.on(this._backBtn, 'click', () => {
                this._modal.hide();
                window.history.back();
            });

            EventHandler.on(this._modalTriggerSSBtn, 'click', () => {
                this._defaultsModal.show();
            });

            EventHandler.on(this.startMultipleRolesJourney, 'click', () => {
                this._defaultsModal.hide();
                this._modal.show();
            })

            EventHandler.on(this.dismissError, 'click', () => {
                this.errorContainer.classList.add('u-hidden');
            });

            EventHandler.on(this.nextSectionCtas, 'click', (event) => {
                event.preventDefault();
                this._finalSubmission();
            });

            forms && forms.forEach((form) => {
                form.addEventListener('change', (event) => {
                    this._openHiddenSections();
                });
            });
    }


    async _finalSubmission() {
        const finalData = Object.assign({}, {
            "primaryRole": this.state.roleType
        })
        const data = await Request.post(this.apiUrl, finalData)
            .catch((e) => {
                this.nextSectionCtas.disabled = false;
                this.errorContainer.classList.remove('u-hidden');
            });

        if(data?.statusCode == '02') {
            window.location.href = this.state.roleRedirectUrl;
        } else {
            this.nextSectionCtas.disabled = false;
            this.errorContainer.classList.remove('u-hidden');
        }
    }

    _openHiddenSections() {
            let roleType = SelectorEngine.findOne('input[name = "roleType"]:checked', this._wrapper);
            if(roleType) {
                this.state.roleType = roleType.getAttribute('data-role');
                this.state.roleRedirectUrl = roleType.getAttribute('data-url');
                this.nextSectionCtas.classList.remove('u-hidden');
                this.nextSectionCtas.disabled = false;
                this.nextSectionCtas.scrollIntoView();
            } else {
                this.nextSectionCtas.classList.add('u-hidden');
                this.nextSectionCtas.disabled = true;
                this.nextSectionCtas.scrollIntoView();
                this.state.roleType = '';
                this.state.roleRedirectUrl = '';
            }
        }
    }

const rolesOnboarding = new RolesOnboarding();

export default rolesOnboarding;

